import React from 'react';
import * as styles from './styles/styles.module.scss';
import { wrapEventHandler } from '../../../utils/handlers';

export default function CardLink({ target, title, url, handleClick, toggleLinkFocus }) {
  const classes = ['xlate-none', styles.link];

  return (
    <a
      itemProp="url"
      target={target}
      onFocus={() => toggleLinkFocus(true)}
      onBlur={() => toggleLinkFocus(false)}
      title={title}
      className={classes.join(' ')}
      href={url}
      onClick={wrapEventHandler(handleClick)}
    >
      {title}
    </a>
  );
}

CardLink.defaultProps = {
  toggleLinkFocus: () => {}
};
